try {
  const getCookie = (key: string): string | null => {
    const filtered: string[][] =
      document.cookie
        .split(';')
        .map(x => x.split('='))
        .filter(x => x[0].replace(/ /, '') === key);
    return !filtered.length ? null : decodeURIComponent(filtered[0][1]);
  }
  const postEvent = (testPatternId: string, url: string, eventType: string, clickId: string | null) => {
    const requestUrl: URL = new URL(String(process.env.WEB_API_URL_EVENT));
    fetch(requestUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Authorization': `Bearer ${process.env.WEB_API_ANON_KEY}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'test_pattern_id': testPatternId,
        'url': url,
        'event_type': eventType,
        'click_id': clickId
      })
    });
  }
  const testId: string | null = getCookie('beastt:test_id');
  if (!testId)
    throw new Error('test_id is undefined');
  const testPatternId: string | null = getCookie('beastt:test_pattern_id');
  if (!testPatternId)
    throw new Error('test_pattern_id is undefined');
  postEvent(
    testPatternId,
    location.href,
    'screen_view',
    null
  );

  // イベントリスナーを保持するためのオブジェクト
  // イベントリスナーを削除する可能性があるが、削除時にリスナーを指定しなければいけないのでこのオブジェクトが必要である。
  const eventListeners: Record<string, EventListener> = {};
  // クリックイベントハンドラ
  const clickEventHandler = (clickId: string) => {
    return () => {
      postEvent(
        testPatternId,
        location.href,
        'click',
        clickId
      );
    };
  }
  // ドキュメントの読み込み完了時にすでに存在するノードへのクリックイベント付与
  const nodeList: NodeListOf<HTMLElement> = document.querySelectorAll('[data-beastt-click-id]');
  nodeList.forEach((node: HTMLElement) => {
    const clickId: string | null = node.getAttribute('data-beastt-click-id');
    if (clickId) {
      const listener = clickEventHandler(clickId);
      node.addEventListener('click', listener);
      eventListeners[clickId] = listener;
    }
  })
  // ドキュメントの読み込み完了後にDOMに変更があった場合の処理
  const mutationCallback = (mutationsList: MutationRecord[]) => {
    mutationsList.forEach((mutation) => {
      // ノードが追加された場合
      mutation.addedNodes.forEach((element: Node) => {
        if (element instanceof HTMLElement && element.hasAttribute('data-beastt-click-id')) {
          const clickId: string | null = element.getAttribute('data-beastt-click-id');
          if (clickId) {
            const listener = clickEventHandler(clickId);
            element.addEventListener('click', listener);
            eventListeners[clickId] = listener;
          }
        }
      });
      // ノードが削除された場合
      mutation.removedNodes.forEach((element) => {
        if (element instanceof HTMLElement && element.hasAttribute('data-beastt-click-id')) {
          const clickId: string | null = element.getAttribute('data-beastt-click-id');
          if (clickId) {
            const listener = eventListeners[clickId];
            element.removeEventListener('click', listener);
          }
        }
      });
      // 既存のノードのdata-beastt-click-idプロパティが変更された場合
      const element = mutation.target as HTMLElement;
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-beastt-click-id') {
        const oldClickId: string | null = mutation.oldValue;
        if (oldClickId) {
          const listener = eventListeners[oldClickId];
          element.removeEventListener('click', listener);
        }
        const newClickId: string | null = element.getAttribute('data-beastt-click-id');
        if (newClickId) {
          const listener = clickEventHandler(newClickId);
          element.addEventListener('click', listener);
          eventListeners[newClickId] = listener;
        }
      }
    });
  };
  // Mutation Observerの設定
  const observer = new MutationObserver(mutationCallback);
  const observerConfig = {
    attributes: true,
    childList: true,
    subtree: true,
    attributeOldValue: true
  };
  observer.observe(document, observerConfig);
} catch (e) {
  console.log(`Beastt: monitor does not work because ${e}`);
  // Do nothing
}
